<mode-toast [type]="type" [showCloseBtn]="showCloseBtn" [canTapToDismiss]="canTapToDismiss" (dismissToast)="dismissToast()">
  {{ message }}
</mode-toast>
